"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerTable = CustomerTable;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("react");
var react_redux_1 = require("react-redux");
var table_empty_state_1 = require("../../../../components/table/tableEmptyState/table_empty_state");
var routes_1 = require("../../../../constants/routes");
var console_1 = require("../../../../reducers/slices/console");
var react_router_dom_1 = require("react-router-dom");
var download_user_records_1 = require("../../../../api/calls/user/download_user_records");
var export_client_users_to_csv_1 = require("../../../../api/calls/user/get/export_client_users_to_csv");
var table_bottom_content_1 = require("../../../../components/table/tableBottomContent/table_bottom_content");
var table_cell_1 = require("../../../../components/table/tableCell/table_cell");
var table_top_content_1 = require("../../../../components/table/tableTopContent/table_top_content");
var tableContext_1 = require("../../../../contexts/tableContext");
var orders_1 = require("../../../../api/orders");
var permissions_1 = require("../../../../hooks/permissions");
var IUser_1 = require("../../../../interfaces/IUser");
var pages_1 = require("../../../../constants/pages");
var useColumns_1 = require("./hooks/useColumns");
var useRenderCellViews_1 = require("./hooks/useRenderCellViews");
var useRowActions_1 = require("./hooks/useRowActions");
var table_fetch_indicator_1 = require("../../../../components/table/tableFetchIndicator/table_fetch_indicator");
function CustomerTable() {
    var _a;
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var tableRef = (0, react_2.useRef)(null);
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    var _b = (0, react_2.useState)({
        page: pages_1.initialPaginationValues.page,
        size: pages_1.initialPaginationValues.size,
        search_string: "",
        user_id: user === null || user === void 0 ? void 0 : user._id,
    }), queryArgs = _b[0], setQueryArgs = _b[1];
    var _c = (0, orders_1.useGetCustomerOrderSummariesQuery)(queryArgs, { skip: !(user === null || user === void 0 ? void 0 : user._id) }), data = _c.data, isLoading = _c.isFetching;
    var customers = (_a = data === null || data === void 0 ? void 0 : data.user_list) !== null && _a !== void 0 ? _a : [];
    // named fields only, so display values never reach the cache key or the query string
    var onQueryParamsChanged = (0, react_2.useCallback)(function (_a) {
        var page = _a.page, size = _a.size, search_string = _a.search_string, status = _a.status, start_date = _a.start_date, end_date = _a.end_date;
        return setQueryArgs(function (previous) { return (__assign(__assign({}, previous), { page: page, size: size, search_string: search_string, status: status, start_date: start_date, end_date: end_date, user_id: user === null || user === void 0 ? void 0 : user._id })); });
    }, [user]);
    var _d = (0, useColumns_1.useColumns)(), columns = _d.columns, excludeSortColumns = _d.excludeSortColumns, headerColumns = _d.headerColumns, 
    // initialSortDescriptor,
    onVisibleColumnsChanged = _d.onVisibleColumnsChanged, setTableColumnConfig = _d.setTableColumnConfig, tableColumnConfig = _d.tableColumnConfig, visibleColumns = _d.visibleColumns;
    var renderCellViews = (0, useRenderCellViews_1.useRenderCellViews)().renderCellViews;
    var rowActions = (0, useRowActions_1.useRowActions)().rowActions;
    var canCreate = (0, permissions_1.usePermission)(IUser_1.IPermissions.CUSTOMERS).canCreate;
    (0, react_2.useEffect)(function () {
        dispatch((0, console_1.setPageTitle)("Customers"));
    }, []);
    var modifiedPagination = (0, react_2.useMemo)(function () {
        var _a, _b, _c;
        return ({
            page: (_a = queryArgs.page) !== null && _a !== void 0 ? _a : 1,
            size: (_b = queryArgs.size) !== null && _b !== void 0 ? _b : pages_1.initialPaginationValues.size,
            countTotal: (_c = data === null || data === void 0 ? void 0 : data.count) !== null && _c !== void 0 ? _c : 0,
            search_string: queryArgs.search_string,
            branch_id_list: (user === null || user === void 0 ? void 0 : user.role) !== "ADMIN" ? user === null || user === void 0 ? void 0 : user.manager_of : null,
        });
    }, [queryArgs, data, user]);
    var badgesToRender = (0, react_2.useMemo)(function () {
        return customers.map(function (customer) {
            return customer;
        });
    }, [customers]);
    var handleRowAction = (0, react_2.useCallback)(function (key) {
        navigate("".concat(routes_1.CONSOLE_ROUTE).concat(routes_1.CUSTOMERS_ROUTE, "/").concat(key));
    }, [navigate, user]);
    var exportCustomers = {
        label: "Export CSV",
        iconClassname: "mdi:export",
        onClick: function () {
            return (0, export_client_users_to_csv_1.get_loyalty_users_download_url)({
                user_id: user === null || user === void 0 ? void 0 : user._id,
            })
                .then(function (data) {
                (0, download_user_records_1.download_user_record_file)(data.content)
                    .then(function (response) {
                    var blob = new Blob([response.file_data], { type: "application/octet-stream" });
                    var url = window.URL.createObjectURL(blob);
                    var link = document.createElement("a");
                    link.href = url;
                    link.download = response.file_name;
                    link.click();
                    window.URL.revokeObjectURL(url);
                })
                    .catch(function (error) {
                    console.log("download_user_record_file error: ", error);
                });
            })
                .catch(function (error) {
                console.log("get_loyalty_users_download_url error: ", error);
            });
        },
    };
    var addCustomer = {
        label: "Add Customer",
        iconClassname: "mdi:plus",
        onClick: function () {
            navigate("".concat(routes_1.CONSOLE_ROUTE).concat(routes_1.CUSTOMERS_ROUTE).concat(routes_1.NEW_ROUTE));
        },
    };
    var actionButtons = canCreate ? [exportCustomers, addCustomer] : [exportCustomers];
    return ((0, jsx_runtime_1.jsx)(tableContext_1.TableContextProvider, { actionButtons: actionButtons, columns: columns, defaultQueryParams: modifiedPagination, excludeSortColumns: excludeSortColumns, headerColumns: headerColumns, isFetching: isLoading, 
        // initialSortDescriptor={initialSortDescriptor}
        onPageChange: onQueryParamsChanged, onVisibleColumnsChanged: onVisibleColumnsChanged, setTableConfig: setTableColumnConfig, tableColumnConfig: tableColumnConfig, pagination: modifiedPagination, visibleColumns: visibleColumns, children: (0, jsx_runtime_1.jsxs)("div", { className: "w-full relative", children: [(0, jsx_runtime_1.jsx)(table_top_content_1.TableTopContent, {}), (0, jsx_runtime_1.jsxs)(react_1.TableRoot, { children: [(0, jsx_runtime_1.jsx)(table_fetch_indicator_1.TableFetchIndicator, {}), (0, jsx_runtime_1.jsx)(react_1.TableScrollContainer, { children: (0, jsx_runtime_1.jsxs)(react_1.TableContent, { "aria-label": "Customers", onRowAction: handleRowAction, ref: tableRef, selectionMode: "single", children: [(0, jsx_runtime_1.jsx)(react_1.TableHeader, { columns: headerColumns, children: function (column) {
                                            var _a;
                                            return ((0, jsx_runtime_1.jsx)(react_1.TableColumn, { id: column.uid, isRowHeader: column.uid === ((_a = headerColumns[0]) === null || _a === void 0 ? void 0 : _a.uid), className: column.uid === "actions" ? "text-center" : "text-start", children: column.name }));
                                        } }), (0, jsx_runtime_1.jsx)(react_1.TableBody, { items: badgesToRender, renderEmptyState: function () { return (0, jsx_runtime_1.jsx)(table_empty_state_1.TableEmptyState, { isLoading: isLoading, message: "No customers found." }); }, children: function (item) { return ((0, jsx_runtime_1.jsx)(react_1.TableRow, { id: item._id, columns: headerColumns, className: "cursor-pointer", children: function (column) { return ((0, jsx_runtime_1.jsx)(react_1.TableCell, { children: (0, jsx_runtime_1.jsx)(table_cell_1.TableCellComponent, { columnRecord: item, columnKey: column.uid, renderCellViews: renderCellViews, rowActions: rowActions }) })); } })); } })] }) }), (0, jsx_runtime_1.jsx)(table_bottom_content_1.TableBottomContent, {})] })] }) }));
}
